// MI-297: minimal country → local-currency map for the onboarding wizard.
// Codes are ISO 3166-1 alpha-2; currencies match the seeded standard set
// (data/seeds/standard_currencies.py). Selecting a country activates its
// currency ON TOP of the seeded COP + USD (option A — additive).
export const COUNTRIES = [
  { code: 'CO', name: 'Colombia', currency: 'COP' },
  { code: 'MX', name: 'México', currency: 'MXN' },
  { code: 'AR', name: 'Argentina', currency: 'ARS' },
  { code: 'CL', name: 'Chile', currency: 'CLP' },
  { code: 'PE', name: 'Perú', currency: 'PEN' },
  { code: 'BR', name: 'Brasil', currency: 'BRL' },
  { code: 'UY', name: 'Uruguay', currency: 'UYU' },
  { code: 'BO', name: 'Bolivia', currency: 'BOB' },
  { code: 'PY', name: 'Paraguay', currency: 'PYG' },
  { code: 'VE', name: 'Venezuela', currency: 'VES' },
  { code: 'EC', name: 'Ecuador', currency: 'USD' },
  { code: 'US', name: 'United States', currency: 'USD' },
  { code: 'CA', name: 'Canada', currency: 'CAD' },
  { code: 'ES', name: 'España', currency: 'EUR' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP' },
];

export function currencyForCountry(code) {
  return COUNTRIES.find((c) => c.code === code)?.currency || null;
}
